const Heart = () => (
  <svg focusable={false} viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
    <path
      fill='none'
      stroke='#000'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M14.5 6.136c0-3.982-6.942-4.468-6.942.265 0 .85.884.85.884 0 0-4.672-6.942-4.247-6.942-.265C1.5 8.718 3.617 11.306 8 13c4.26-1.651 6.5-4.184 6.5-6.864z'
    />
  </svg>
);

export default Heart;
